import React from 'react';

import { Box } from '@clutter/clean';

import { ButtonCTA } from '@shared/button_cta';
import { ServiceSelection } from '@shared/service_selector/constants';

export const StandaloneCTA = ({
  align,
  background,
  label,
  removeTopPadding,
  service,
  trackingContainer,
}: {
  align?: 'left' | 'center' | 'right';
  background: string;
  label?: string;
  removeTopPadding?: boolean;
  service?: ServiceSelection;
  trackingContainer: string;
}) => (
  <Box
    padding={
      removeTopPadding
        ? ['0 24px 40px', '0 60px 40px']
        : ['40px 24px', '40px 60px']
    }
    background={background}
    textAlign={align ?? 'center'}
  >
    <ButtonCTA
      container={trackingContainer}
      service={service}
      label={label ?? 'Get Started'}
      entryPoint="landing_page_cta"
    />
  </Box>
);
